// premium-refine: micro-labels for section structure
import React from 'react';

interface MicroLabelProps {
  children: React.ReactNode;
  className?: string;
}

export const MicroLabel = ({ children, className = "" }: MicroLabelProps) => {
  return (
    <div className={`text-[11px] font-semibold tracking-[0.08em] uppercase text-muted-foreground/65 mb-4 ${className}`}>
      {children}
    </div>
  );
};